import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import DropdownSelector from "../../../atoms/Common/DropdownSelector";
import { getPurchaseOrderList } from "../../../api/purchaseOrders";
import { FastField, useFormikContext } from "formik";
import { getUserWarehousesByUserId } from "../../../api/userWarehouses";
import { useUser } from "../../../context/UserContext";
import MyDatePicker from "../../../atoms/Common/MyDatePicker";

interface FormValues {
  inbound: {
    companyId: number | null;
    purchaseOrderId: number | null;
    description: string;
    warehouseId: number | null;
    inboundDate: any;
  };
  inboundItems: Array<{
    poItemId: number | null;
    description: string;
    deliveryNo: number;
    quantityDelivered: number;
    weight: number;
    productId: number | null;
    unitId: number | null;
  }>;
}

interface InboundHeaderProps {
  companyId: number;
  onPurchaseOrderChange: (poId: number) => void;
  onLoadPOItems?: () => void;
}

const InboundHeader: React.FC<InboundHeaderProps> = ({
  companyId,
  onPurchaseOrderChange,
  onLoadPOItems,
}) => {
  const { userData } = useUser();
  const { values, setFieldValue } = useFormikContext<FormValues>();

  const handlePurchaseOrderSelect = (event: any, value: any) => {
    const poId = value?.id;
    setFieldValue("inbound.purchaseOrderId", poId);
    onPurchaseOrderChange(poId);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Nota de entrada
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FastField
            name="inbound.purchaseOrderId"
            as={DropdownSelector}
            label="Orden de Compra"
            fetchFunction={getPurchaseOrderList}
            fetchParams={{ companyId, statusCodes: ["PO_APROBADA", "PO_PARTIALLY_DELIVERED"], pageSize: 1000 }}
            optionLabel={["code"]}
            onChange={handlePurchaseOrderSelect}
            value={values.inbound.purchaseOrderId}
          />
        </Grid>
        {onLoadPOItems && (
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={onLoadPOItems}
              disabled={!values.inbound.purchaseOrderId}
              fullWidth
            >
              Cargar datos
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <FastField
            name="inbound.warehouseId"
            as={DropdownSelector}
            label="Almacén"
            fetchFunction={getUserWarehousesByUserId}
            fetchParams={userData.id}
            optionLabel={"warehouse.name"}
            margin="normal"
            fullWidth
            value={values.inbound.warehouseId}
            keyField = {"warehouseId"}
          />
        </Grid>
        <Grid item xs={12}>
          <MyDatePicker
            label="Fecha de Ingreso"
            value={values.inbound.inboundDate}
            onChange={(date) => setFieldValue("inbound.inboundDate", date)}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField
            name="inbound.description"
            as={TextField}
            label="Observaciones "
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            margin="normal"
            value={values.inbound.description}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InboundHeader;
